import React, { Component } from 'react'
import MainTopbarContainer from 'containers/main_topbar/container'

class MainHeader extends Component {
	render() {
		return (<MainTopbarContainer />)
	}
}

export default MainHeader
